import { Form, Table } from 'antd';
import { TableRowSelection } from 'antd/es/table/interface';
import { TableProps } from 'antd/lib';
import { useState } from 'react';
import { useAddCreditLimitMutation } from '../api/creditLimitApi';
import { ICreditLimitList, IPostCreditLimit } from '../type/CreditLimit.interface';
import CreditLimitColumn from '../utils/CreditLimitColumn';
import { TargetEditableCell } from './TargetEditableCell';

type Props = {
  isLoading: boolean;
  data: ICreditLimitList[] | undefined;
  rowSelection: TableRowSelection<ICreditLimitList>;
};

const ClientTargetTable = ({ data, isLoading: GETLoading, rowSelection }: Props) => {
  const [form] = Form.useForm();

  const [addCreditLimit, { isLoading }] = useAddCreditLimitMutation();

  const [editingKey, setEditingKey] = useState('');

  const isEditing = (record: ICreditLimitList) => String(record.client_id) === editingKey;

  const edit = (record: Partial<ICreditLimitList>) => {
    form.setFieldsValue({ ...record });
    setEditingKey(String(record.client_id));
  };

  const cancel = () => {
    setEditingKey('');
  };

  const save = async () => {
    try {
      const row = (await form.validateFields()) as IPostCreditLimit;

      const res: any = await addCreditLimit([{ ...row, client_id: Number(editingKey) }]);
      if (res?.data?.success) {
        setEditingKey('');
        form.resetFields();
      }
    } catch (errInfo) {
      console.log('Validate Failed:', errInfo);
    }
  };

  const mergedColumns: TableProps<ICreditLimitList>['columns'] = CreditLimitColumn({
    isEditing,
    editingKey,
    isLoading,
    save,
    cancel,
    edit,
  }).map((col: any) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: ICreditLimitList) => ({
        record,
        inputType: col.dataIndex,
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Form form={form} component={false}>
      <Table<ICreditLimitList>
        rowSelection={rowSelection}
        components={{
          body: { cell: TargetEditableCell },
        }}
        bordered
        dataSource={data}
        columns={mergedColumns}
        scroll={{ y: 800 }}
        rowKey='key'
        virtual
        rowClassName='editable-row'
        size='small'
        pagination={false}
        className='compact-table'
        prefixCls='inventive-table'
        loading={GETLoading || isLoading}
      />
    </Form>
  );
};

export default ClientTargetTable;
